// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/lolla24.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/BullsBarclay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/helvetica.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/helvetica.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Core CSS required for Ionic components to work properly
@import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic
@import '@ionic/react/css/normalize.css';
@import '@ionic/react/css/structure.css';
@import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out
@import '@ionic/react/css/padding.css';
@import '@ionic/react/css/float-elements.css';
@import '@ionic/react/css/text-alignment.css';
@import '@ionic/react/css/text-transformation.css';
@import '@ionic/react/css/flex-utils.css';
@import '@ionic/react/css/display.css';
*/

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.Splash{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;        /* Ensures the image scales proportionally */
  background-position: center;   /* Centers the image */
  background-repeat: no-repeat;  /* Prevents tiling */
  height: 100vh;                 /* Ensures full viewport height */
  width: 100vw;                  /* Ensures full viewport width */
  overflow: hidden;              /* Prevents scrolling issues */
}

.BullsBarclay{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;        /* Ensures the image scales proportionally */
  background-position: center;   /* Centers the image */
  background-repeat: no-repeat;  /* Prevents tiling */
  height: 100vh;                 /* Ensures full viewport height */
  width: 100vw;                  /* Ensures full viewport width */
  overflow: hidden;              /* Prevents scrolling issues */
}

@font-face {
    font-family: 'Helvetica';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;CAeC;;AAED;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yDAAoD;EACpD,sBAAsB,SAAS,4CAA4C;EAC3E,2BAA2B,IAAI,sBAAsB;EACrD,4BAA4B,GAAG,oBAAoB;EACnD,aAAa,kBAAkB,iCAAiC;EAChE,YAAY,mBAAmB,gCAAgC;EAC/D,gBAAgB,eAAe,8BAA8B;AAC/D;;AAEA;EACE,yDAAyD;EACzD,sBAAsB,SAAS,4CAA4C;EAC3E,2BAA2B,IAAI,sBAAsB;EACrD,4BAA4B,GAAG,oBAAoB;EACnD,aAAa,kBAAkB,iCAAiC;EAChE,YAAY,mBAAmB,gCAAgC;EAC/D,gBAAgB,eAAe,8BAA8B;AAC/D;;AAEA;IACI,wBAAwB;IACxB;mEAC2D;IAC3D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Core CSS required for Ionic components to work properly\n@import '@ionic/react/css/core.css';\n\n/* Basic CSS for apps built with Ionic\n@import '@ionic/react/css/normalize.css';\n@import '@ionic/react/css/structure.css';\n@import '@ionic/react/css/typography.css';\n\n/* Optional CSS utils that can be commented out\n@import '@ionic/react/css/padding.css';\n@import '@ionic/react/css/float-elements.css';\n@import '@ionic/react/css/text-alignment.css';\n@import '@ionic/react/css/text-transformation.css';\n@import '@ionic/react/css/flex-utils.css';\n@import '@ionic/react/css/display.css';\n*/\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.Splash{\n  background-image: url('./assets/images/lolla24.png');\n  background-size: cover;        /* Ensures the image scales proportionally */\n  background-position: center;   /* Centers the image */\n  background-repeat: no-repeat;  /* Prevents tiling */\n  height: 100vh;                 /* Ensures full viewport height */\n  width: 100vw;                  /* Ensures full viewport width */\n  overflow: hidden;              /* Prevents scrolling issues */\n}\n\n.BullsBarclay{\n  background-image: url('./assets/images/BullsBarclay.png');\n  background-size: cover;        /* Ensures the image scales proportionally */\n  background-position: center;   /* Centers the image */\n  background-repeat: no-repeat;  /* Prevents tiling */\n  height: 100vh;                 /* Ensures full viewport height */\n  width: 100vw;                  /* Ensures full viewport width */\n  overflow: hidden;              /* Prevents scrolling issues */\n}\n\n@font-face {\n    font-family: 'Helvetica';\n    src: url('./assets/fonts/helvetica.woff') format('woff'),\n         url('./assets/fonts/helvetica.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
